import {NodeCodeChunk} from "../../chunks/types/NodeCodeChunk";

export function getSpreadOpFromNodeCodeChunk(
  nodeCodeChunk: NodeCodeChunk
): string | null {
  const {
    captures: {
      1: spreadOpChunk
    }
  } = nodeCodeChunk;
  return spreadOpChunk ?
    spreadOpChunk.captures[0] :
    null;
}
